import { useQuery } from "@tanstack/react-query";
import { AXIOS_RESERVATION } from "../utils/axios-interceptors";
import { IUseGetOurStoryQueryResponse } from "../utils/types";

const useGetOurStory = (): IUseGetOurStoryQueryResponse => {
  return useQuery({
    queryKey: ["our-story"],
    queryFn: async () => {
      const response = await AXIOS_RESERVATION.get(`/our-stories`);
      return response.data;
    },
  });
};

export default useGetOurStory;
